export default `/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([suppress-error-message]) .validation-message {
  display: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
  width: var(--ids-box-dropdown-width, auto);
}

:host([field-indicator]) {
  --ids-field-indicator-info-margin: 0;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

:host([hidden]) {
  display: none;
}

:host([label-position=inline-start]) ids-trigger-field::part(container) {
  justify-content: var(--ids-box-justify-content, flex-start);
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-color-transparent);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}
.ids-dropdown ::slotted(ids-list-box) {
  height: var(--ids-popup-maxheight);
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

:host([combobox]) .ids-dropdown.color-variant-borderless .ids-trigger-field-slot-trigger-end {
  display: flex;
  align-items: center;
  margin-block-start: 2px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-lg .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
  height: 48px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-md .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  height: 39px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-sm .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -5px;
  height: 33px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  height: 29px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xxs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  margin-block-start: 0;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}

:host([auto-size=true]) ids-trigger-field::part(input) {
  padding-inline-end: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
